/*
 * @Description: 业务管理系统
 * @Author: fxg
 * @Date: 2020-06-29 11:18:28
 * @LastEditors: fxg
 * @LastEditTime: 2020-06-29 13:34:36
*/
import request from '@/utils/request'

export const Download = "/base/system/business/export";
export function batchUpdateOrDelete(data) {
  return request({
    url: '/base/system/business/batch_update_or_delete',
    method: 'post',
    data
  })
}
export function getDetail() {
  return request({
    url: '/base/system/business/get_detail',
    method: 'get'
  })
}
export function queryPage(data) {
  return request({
    url: '/base/system/business/query_page',
    method: 'post',
    data
  })
}
export function queryBusinessList(data) {
  return request({
    url: '/base/system/business/getBusinessSystemByUserAuthList',
    method: 'post',
    data
  })
}

export function saveOrUpdate(data) {
  return request({
    url: '/base/system/business/save_or_update',
    method: 'post',
    data
  })
}
export function updateSortNum(data) {
  return request({
    url: '/base/system/business/update_sort_num',
    method: 'post',
    data
  })
}
export function getSystemlist() {
  return request({
    url: '/base/system/business/get_system_list',
    method: 'get',
  })
}

/**
 * 获取数据源列表。不翻页
 * @param {查询参数}} data 
 * @returns 
 */
export function getDataSourceList(data) {
  return request({
    url: '/base/system/business/datasource/getList',
    method: 'post',
    data
  })
}

/**
 * 保存或者更细数据源
 * @param {数据源对象} data 
 * @returns 
 */
export function saveOrUpdateDataSource(data) {
  return request({
    url: '/base/system/business/datasource/save_or_update',
    method: 'post',
    data
  })
}

/**
 * 获取数据库的所有表格
 * @param {dataSourceId} params 
 * @returns 
 */
export function getTableList(params) {
  return request({
    url: '/base/system/db/get_tables',
    params
  })
}

/**
 * 获取数据库的某个表的所有列
 * @param {dataSourceId, tableName} params 
 * @returns 
 */
 export function getTableColumnList(params) {
  return request({
    url: '/base/system/db/get_columns',
    params
  })
}